import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

export default class CommunicationLogService extends CrudRequest {
  static baseUrl() {
    return '/communication/logs';
  }

  static list(id, params = {}) {
    return httpService.get(
      `${this.baseUrl()}/${id}`,
      {
        params,
      },
    );
  }
}
